import PaymentDetails from "../PaymentReceiptComponents/PaymentDetails";

const PaymentDetailPage = () => {
	return(
		<PaymentDetails/>
	)
};

export default PaymentDetailPage;
